<ng-container *ngIf="showUserInfoPromptModal">
    <div class="modal-background"></div>
    <div class="modal">
        <div class="modal-header">
            Zur Verwendung sind folgende Informationen notwendig:
        </div>
        <div class="modal-body">
            <div *ngFor="let field of requiredFields">
                <label [for]="field.key">{{field.label}}</label>
                <input [type]="field.type" [name]="field.key" [(ngModel)]="field.value" [placeholder]="field.placeholder" />
            </div>
        </div>
        <div class="modal-footer">
            <button class="button primary" (click)="saveUserInfo()" [disabled]="!userInfoValid">Übernehmen</button>
        </div>
    </div>
</ng-container>